import { render, staticRenderFns } from "./RecursiveSubmenu.vue?vue&type=template&id=481c9514"
import script from "./RecursiveSubmenu.vue?vue&type=script&lang=js"
export * from "./RecursiveSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports